import { z } from 'zod';

/**
 * Create dynamic Zod schema based on validation rules
 * @returns {z.ZodType}
 */
export const createValidationSchema = () => {
  const baseSchema = z.object({
    id: z.string().optional(),
    order: z.string().optional(),
    position: z.number().nullable().optional(),
  })
    // Allow empty id and order
    .refine((data) => {
      // if type is defined, it must be non empty
      if (data.id !== undefined && data.id !== null) {
        return data.id.trim().length > 0;
      }
      return true;
    }, {
      message: 'filters.id.required',
      path: ['id'],
    })
    .refine((data) => {
      // if id is defined, order must also be defined
      if (data.id && data.id.trim().length > 0) {
        return data.order && data.order.trim().length > 0;
      }
      return true;
    }, {
      message: 'filters.order.required',
      path: ['order'],
    });

  return z.object({
    filters: z.array(baseSchema).optional().default([]),
  });
};

/**
 * Format the initial sorting
 * @param {ApiManagerTableFiltersSortByCriteriaValue[]} initialValuesSorting
 * @returns {import('@tanstack/react-table').SortingState}
 */
export const formatInitialSorting = (initialValuesSorting) => (initialValuesSorting?.length ? initialValuesSorting.map((item) => ({
  id: item.id,
  desc: item.order === 'desc',
})) : []);

/**
 * Get the order preselected when a sort criteria is chosen: ascending when available
 * @param {ApiManagerTableFiltersSortByCriteria | undefined} criteria
 * @returns {'asc' | ''}
 */
export const getDefaultSortOrder = (criteria) => (criteria?.orderOptions?.includes('asc') ? 'asc' : '');
